module.exports = __webpack_public_path__ + "img/porta-op1.8e7e505a.png";